import { render, staticRenderFns } from "./add_brand.vue?vue&type=template&id=a0d356da&scoped=true&"
import script from "./add_brand.vue?vue&type=script&lang=ts&"
export * from "./add_brand.vue?vue&type=script&lang=ts&"
import style0 from "./add_brand.vue?vue&type=style&index=0&id=a0d356da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d356da",
  null
  
)

export default component.exports